import { Environment } from './environment.default';

export const environment: Environment = {
  production: false,
  cloud: true,
  version: require('../../../../package.json').version,
  cookieDomain: 'jax.org',
  auth: {
    domain: 'thejacksonlaboratory.auth0.com',
    clientId: 'TqMjJjlJW5PdFDQsfkUrhsvjoGk72jew',
    authorizationParams: {
      redirect_uri: `${window.location.origin}/`,
      audience: 'https://cube.jax.org',
    },
  },
  securedURLs: {
    cimg: 'https://imagetools-dev.jax.org/api',
  },
  unsecuredURLs: {},
  featureFlags: {},

  slideCropServer: 'https://imagetools-dev.jax.org/api/',
  temporalServer: 'https://temporal.jax-cluster-dev-10.jax.org/namespaces/cimg-dev/workflows',
  titleSuffix: 'Dev',
  // One model server serves every JIT instance; see model-server/README in
  // jit-extensions for why it is hosted on dev.
  browserModelServer: 'https://imagetools-dev.jax.org/models/v1',
};
